import pretty from "Shared/pretty";
import { Metrics } from "Shared/types/Employer";

type MetricBoxData = {
  title: string;
  valueSuffix: string;
  getValue: (metrics: Metrics) => string;
  footer: string;
};

const overviewSectionMetricBoxes: MetricBoxData[] = [
  {
    title: "Dollars Transferred",
    getValue: ({ transferredLast7DaysCents }: Metrics) =>
      pretty.dollar(transferredLast7DaysCents, "$0,0", {
        abbreviate: true,
      }),
    valueSuffix: "Total",
    footer: "past 7 days",
  },
  {
    title: "Gross Earnings Reported",
    getValue: ({ withRecentInvoices, eligible }: Metrics) =>
      `${eligible ? ((withRecentInvoices / eligible) * 100).toFixed(0) : 0}%`,
    valueSuffix: "of Users",
    footer: "past 24 hours",
  },
  {
    title: "Enrollment",
    getValue: ({ active, eligible }: Metrics) =>
      `${eligible ? ((active / eligible) * 100).toFixed(0) : 0}%`,
    valueSuffix: "of Eligible Users",
    footer: "as of today",
  },
  {
    title: "Engaged",
    getValue: ({ champions, eligible }: Metrics) =>
      `${eligible ? ((champions / eligible) * 100).toFixed(0) : 0}%`,
    valueSuffix: "of Eligible Users",
    footer: "as of today",
  },
];

export default overviewSectionMetricBoxes;
